import React from 'react';
import { useTranslation } from 'react-i18next';
import styles from './FreeTrialCard.module.scss';
import FreeTrialCollarImage from '../../assets/images/free_trial_collar.png';

interface FreeTrialCardProps {
  onStartFreeTrial: () => void;
}

const FreeTrialCard: React.FC<FreeTrialCardProps> = ({ onStartFreeTrial }) => {
  const { t } = useTranslation();

  return (
    <div className={styles.freeTrialSection}>
      <div className={styles.freeTrialSectionTitle}>{t('try_before_you_buy')}</div>
      <div className={styles.freeTrialCard}>
        <img className={styles.freeTrialImage} src={FreeTrialCollarImage} alt={t('free_trial_refurbished')} />
        <div className={styles.freeTrialCardBody}>
          <div className={styles.freeTrialCardTitle}>{t('free_trial_refurbished')}</div>
          <div className={styles.freeTrialCardDescription}>{t('experience_fi_for_free_on_a_refurbished_device')}</div>
          <button className={styles.freeTrialCardButton} onClick={onStartFreeTrial}>
            {t('add_to_cart')}
          </button>
        </div>
      </div>
    </div>
  );
};

export default FreeTrialCard;
